import { dcCrossConnectTypeOptions } from "@/common/const";
import { includedOptions } from "@/common/const/filter-options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const dcCrossConnectResStrategy: ResponseFormElementsType[] = [
  {
    type: "text",
    attribute: "provider",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "quantity",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^[0-9]+$/, 
    patternMessage: "Quantity must be a valid number.",
  },
  {
    type: "select",
    attribute: "DcServiceType",
    required: true,
    options: dcCrossConnectTypeOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "select",
    attribute: "isLocalTax",
    required: true,
    options: includedOptions,
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "select",
    attribute: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "localTax",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^[0-9]+(\.[0-9]+)?$/, 
    patternMessage: "Local tax must be a valid number.",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];
export default dcCrossConnectResStrategy;
